import React, { useState, useRef } from 'react'
import VStack from './VStack'
import RStack from './RStack'
import MenuBar from './MenuBar'
import Intro from './Intro'
import Doctors from './Doctors'
import Treatments from './Treatments'
import Appointments from './Appointments'
import Footer from './Footer'
import useWindowSize from './useWindowSize'
import Data from './data/Data'

/*
phone L=734 P=393
tablet L=1180 P=820
*/

const theme = Data.theme

const componentStyles = {
  small: {
    container: {
      root: {
        overflow: 'none',
      }
    },
    sectionContainer: {
      root: {
        padding: '40px 10px',
      }
    },
    sectionContainerAlt: {
      root: {
        background: '#f0f0f0',
        padding: '40px 10px',
      }
    },
    header: {
      root: {
        padding: 0,
        fontSize: 32,
        fontWeight: 500,
        alignSelf: 'center',
        color: theme.colours.text
      }
    },
    cc: {
      root: { position: 'relative' }
    }
  },
  medium: {
    container: {
      root: {
      }
    },
    sectionContainer: {
      root: {
        padding: '40px 10px',
      }
    },
    sectionContainerAlt: {
      root: {
        background: '#f0f0f0',
        padding: '40px 10px',
      }
    },
    header: {
      root: {
        padding: 0,
        fontSize: 32,
        fontWeight: 500,
        alignSelf: 'center',
        color: theme.colours.text
      }
    },
    cc: {
      root: { position: 'relative' }
    }
  },
  large: {
    container: {
      root: {
      }
    },
    sectionContainer: {
      root: {
        padding: '40px 10px',
      }
    },
    sectionContainerAlt: {
      root: {
        background: '#f0f0f0',
        padding: '40px 10px',
      }
    },
    header: {
      root: {
        padding: 0,
        fontSize: 32,
        fontWeight: 500,
        alignSelf: 'center',
        color: theme.colours.text
      }
    },
    cc: {
      root: { position: 'relative' }
    }
  }
}

const shadowStyle = '0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)'

export default function App() {

  const appointmentRef = useRef(null)
  const practitionersRef = useRef(null)
  const treatmentsRef = useRef(null)

  const { width } = useWindowSize()
  const size = (w => {
    if (w < 700) {
      return 'small'
    } else if (w < 850) {
      return 'medium'
    } else {
      return 'large'
    }
  })(width)

  const cStyles = componentStyles[size] ?? {}

  return (
    <VStack styles={cStyles.container}>
      <MenuBar size={size} fixed shadowStyle={shadowStyle}
        menuSelectCallback={handleMenuSelected}
        //allRefs={{ homeRef, aboutRef, practitionersRef, mediaRef, associationsRef }}
        styles={{ root: { background: 'white' } }}
      //closeCallback={closeCallback}
      />
      {/* <span>Width: {width}</span> */}
      <VStack styles={cStyles.sectionContainer}>
        <RStack size={size} styles={cStyles.cc}>
          <Intro size={size} menuSelectCallback={handleMenuSelected} />
        </RStack>
      </VStack>
      <div ref={practitionersRef} />
      <VStack styles={{ root: { background: '#f4f4f4', padding: '40px 10px' } }}>
        <VStack styles={cStyles.header}>
          Our practitioners
        </VStack>
        <Doctors size={size} />
      </VStack>
      <div ref={treatmentsRef} />
      <VStack styles={{ root: { background: 'white', padding: '40px 10px' } }}>
        <VStack styles={cStyles.header}>
          Treatments
        </VStack>
        <Treatments size={size} />
      </VStack>
      <div ref={appointmentRef} />
      <VStack
        styles={{ root: { background: '#f4f4f4', padding: '40px 10px' } }}
      >
        <VStack styles={cStyles.header}>
          Appointments
        </VStack>
        <VStack styles={{
          root: {
            padding: '10px 20px 10px', fontSize: 16, alignSelf: 'center',
            color: theme.colours.text
          }
        }}>
          For more information or to book an appointment call or email us.
        </VStack>
        <Appointments size={size} />
      </VStack>
      {/* <VStack styles={{ root: { background: 'white', padding: '40px 10px 200px' } }}>
                <VStack styles={cStyles.header}>
                    Media releases
                </VStack>
                <Media size={size} />
            </VStack> */}
      <VStack styles={{ root: { background: theme.colours.primary } }}>
        <Footer size={size} />
      </VStack>
    </VStack>
  )

  function handleMenuSelected(key) {
    switch (key) {
      case 'home':
        window.scrollTo(0, 0)
        //homeRef.current.scrollIntoView({ behavior: "smooth" })
        break
      case 'appointments':
        window.scrollTo(0, appointmentRef.current.offsetTop - 80)
        break
      case 'practitioners':
        window.scrollTo(0, practitionersRef.current.offsetTop - 80)
        break
        case 'treatments':
          window.scrollTo(0, treatmentsRef.current.offsetTop - 80)
          break
    }
  }
}